import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import { Avatar, Button } from '@mui/material'
import ChatIconGreen from '../assets/imgs/chat-icon-green.svg'
import moment from 'moment'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'
import { ScaleLoader } from 'react-spinners'
import { useNavigate } from 'react-router-dom'
import UserImagePlaceholder from '../assets/imgs/user-image-placeholder.png'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const ServiceScheduledModal = ({
  handleServiceScheduleModal,
  serviceScheduleModal = false,
  description,
  selectedService,
}) => {
  const navigate = useNavigate()
  const localStylist = JSON.parse(localStorage.getItem('stylist_profile'))
  const localService = JSON.parse(localStorage.getItem('selected_service'))
  const [isLoading, setIsLoading] = React.useState(false)
  const user = JSON.parse(localStorage.getItem('user'))
  const [confimedMessageModal, setConfimedMessageModal] = React.useState(false)

  const handleConfirmedMessageModal = () => {
    if (serviceScheduleModal) {
      handleServiceScheduleModal(false)
    }
    setConfimedMessageModal(!confimedMessageModal)
  }

  const handleServiceBookingByClient = async () => {
    let body = {
      user_id: user?.id,
      stylist_id: localStylist?.id,
      service_id: selectedService?.id,
      date: selectedService?.date,
      time: selectedService?.time,
      timeslot: selectedService?.timeslot,
      price: selectedService?.price,
      latitude: selectedService?.latitude,
      longitude: selectedService?.longitude,
      address: selectedService?.address,
      travel_charges:
        selectedService?.provider?.travel_charges ?? user?.travel_charges,
    }
    setIsLoading(true)
    let response = await saveOrUpdateDataById('make-reservation', body)
    setIsLoading(false)
    if (response?.success === true) {
      navigate('/services')
      Swal.fire({
        icon: 'success',
        timer: 3000,
        title: 'Booking created successfully!',
        confirmButtonColor: '#2597F6',
      })
      handleServiceScheduleModal(false)
    }
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 5000,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={serviceScheduleModal}
        onClose={() => handleServiceScheduleModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="confirmation-modal">
          <div className="text-center">
            <h3 className="fs-24 fw-bold mb-3">Service Scheduled</h3>
            <div className="m-auto">
              {localStylist?.profile_image && (
                <Avatar
                  src={localStylist?.profile_image}
                  sx={{ height: 120, width: 120 }}
                  className="m-auto"
                />
              )}
              {!localStylist?.profile_image && (
                <Avatar
                  src={UserImagePlaceholder}
                  sx={{ height: 120, width: 120 }}
                  className="m-auto"
                />
              )}
            </div>
            <p className="fs-16 fw-bold mt-2">{`${localStylist?.first_name} ${localStylist?.last_name}`}</p>
            <p className="fs-18">{localStylist?.title}</p>
            <Button disableElevation className="pointer w-75 transparent mt-3">
              {moment(localService?.date).format('MMM DD, YYYY')}
            </Button>
            <Button disableElevation className="pointer w-75 transparent mt-2">
              {selectedService?.timeslot?.split('-').join(' - ')}
            </Button>
            <p className="fs-16 text-left mt-4 fw-bold">
              Start a conversation with your stylist
            </p>
            <div className="mt-3 d-flex gap-1">
              {localStylist?.profile_image && (
                <Avatar
                  src={localStylist?.profile_image}
                  sx={{ height: 36, width: 36 }}
                  className="m-auto"
                />
              )}
              {!localStylist?.profile_image && (
                <Avatar
                  src={UserImagePlaceholder}
                  sx={{ height: 36, width: 36 }}
                  className="m-auto"
                />
              )}
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="text-left">
                  <p className="fs-16 fw-bold">{`${localStylist?.first_name} ${localStylist?.last_name}`}</p>
                  <div className="fs-12 opacity-25">
                    Replies within 5 minutes
                  </div>
                </div>
                <img src={ChatIconGreen} alt="Chat Icon" height={20} />
              </div>
            </div>
            <Button
              disableElevation
              fullWidth
              id="btn-primary-no-shadow"
              className="mt-5 pointer"
              onClick={handleServiceBookingByClient}
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default ServiceScheduledModal
